import {
  OrderHistoryTransactionOrderLine,
  OrderHistoryOperations as HistoryOperations, OrderHistoryTransactionGift, Maybe, OrderHistoryTransactionGiftCardProduct
} from "lib/types/generated/graphql-types"

export class OrderHistoryOperations {
  private readonly orderHistoryOperations: Maybe<HistoryOperations> | undefined

  constructor(orderHistoryOperations: Maybe<HistoryOperations> | undefined) {
    this.orderHistoryOperations = orderHistoryOperations
  }

  public getDeliveredOrderLine(lineId: string): OrderHistoryTransactionOrderLine | undefined {
    return this?.orderHistoryOperations?.delivered?.orderLines?.find((ol) => ol?.orderLineId === lineId)
  }

  public getDeliveredGift(lineId: string): OrderHistoryTransactionGift | undefined {
    return this?.orderHistoryOperations?.delivered?.gifts?.find((ol) => ol?.giftId === lineId)
  }

  public getDeliveredGiftCardProduct(lineId: string): OrderHistoryTransactionGiftCardProduct | undefined {
    return this?.orderHistoryOperations?.delivered?.giftCardProducts?.find((ol) => ol?.giftCardProductId === lineId)
  }

  public getRefundedOrderLine(lineId: string): OrderHistoryTransactionOrderLine | undefined {
    return this?.orderHistoryOperations?.refunded?.orderLines?.find((ol) => ol?.orderLineId === lineId)
  }

  public getRefundedGiftCardProduct(lineId: string): OrderHistoryTransactionGiftCardProduct | undefined {
    return this?.orderHistoryOperations?.refunded?.giftCardProducts?.find((ol) => ol?.giftCardProductId === lineId)
  }

  public getRefundedGift(lineId: string): OrderHistoryTransactionGift | undefined {
    return this?.orderHistoryOperations?.refunded?.gifts?.find((ol) => ol?.giftId === lineId)
  }

  public getReleasedOrderLine(lineId: string): OrderHistoryTransactionOrderLine | undefined {
    return this?.orderHistoryOperations?.released?.orderLines?.find((ol) => ol?.orderLineId === lineId)
  }

  public getReleasedGift(lineId: string): OrderHistoryTransactionGift | undefined {
    return this?.orderHistoryOperations?.released?.gifts?.find((ol) => ol?.giftId === lineId)
  }

  public getReleasedGiftCardProduct(lineId: string): OrderHistoryTransactionGiftCardProduct | undefined {
    return this?.orderHistoryOperations?.released?.giftCardProducts?.find((ol) => ol?.giftCardProductId === lineId)
  }

}
